import React from 'react';
import {
  chakra,
  Box,
  Link,
  LinkBox,
  LinkOverlay,
  useColorModeValue,
  SimpleGrid,
  Image,
  Flex,
} from "@chakra-ui/react";

import landing_img from '../assets/images/landing.jpg';
import hide_it_app from '../assets/images/hide_it_app.png';
import vault_app from '../assets/images/vault_app.png';
import play_badge from '../assets/images/play-badge.png';

const hideit_link = 'https://play.google.com/store/apps/details?id=com.virginm.hideit';
const vault_link = 'https://play.google.com/store/apps/details?id=com.virginm.photovault';

const hideit_privacy_link = 'https://hideit-app-terms.web.app/';
const vault_privacy_link = 'https://photo-vault-app-terms.web.app/';
const contact_link = 'mailto:contactviniwida@gmail.com'

const Landing = () => {

  return (
    <Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        bg={useColorModeValue("white", "brand.500")}
        px={8}
        py={10}
        mx="auto"
      >
        <Box
          w={{ base: "full", md: 11 / 12, xl: 9 / 12 }}
          mx="auto"
          pr={{ md: 20 }}
        >
          <chakra.h2
            fontSize={{ base: "3xl", sm: "4xl" }}
            fontWeight="extrabold"
            lineHeight="shorter"
            color={useColorModeValue("black", "gray.100")}
            mb={6}
          >
            <chakra.span display="block">Virgin Master</chakra.span>
          </chakra.h2>
          <chakra.h4
            fontSize={{ base: "1xl", sm: "xl" }}
            fontWeight="extrabold"
            lineHeight="shorter"
            color={useColorModeValue("black", "gray.100")}
            mb={6}
          >
            <chakra.span
              display="block"
              color={useColorModeValue("#00aaff", "#00aaff")}
            >
              Perfect world, different thinking.
            </chakra.span>
          </chakra.h4>
          <chakra.p
            mb={6}
            fontSize={{ base: "lg", md: "xl" }}
            color={useColorModeValue("gray", "gray")}
          >
            A team of technology professionals who continuously strive to provide smarter solutions to our customers
          </chakra.p>
        </Box>
        <Box w={{ base: "full", md: 10 / 12 }} mx="auto" textAlign="center">
          <Image
            w="full"
            rounded="lg"
            shadow="2xl"
            src={landing_img}
            alt="Laptop on a table with a code editor open"
          />
        </Box>
      </Flex>
      <Flex
        bg={useColorModeValue("white", "brand.500")}
        px={20}
        py={5}
        w="auto"
        justifyContent="center"
        alignItems="center"
      >
        <Box>
          <chakra.h2
            fontSize={{ base: "3xl", sm: "4xl" }}
            fontWeight="extrabold"
            lineHeight="shorter"
            color={useColorModeValue("black", "gray.100")}
            // mb={6}
          >
            <chakra.span display="block">Our Products</chakra.span>
          </chakra.h2>
        </Box>
      </Flex>
      <Flex
        bg={useColorModeValue("white", "brand.500")}
        px={20}
        py={5}
        w="auto"
        justifyContent="center"
        alignItems="center"
      >
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={0}>
          <Flex bg="brand.400">
            <Image
              src={hide_it_app}
              alt="Mobile phone with an app open"
              fit="cover"
              w="full"
              h={{ base: 64, md: "full" }}
              loading="lazy"
            />
          </Flex>
          <Flex
            direction="column"
            alignItems="center"
            justifyContent="center"
            px={{ base: 4, md: 8, lg: 20 }}
            py={24}
            zIndex={3}
          >
            <chakra.span
              color={useColorModeValue("brand.600", "gray.300")}
              fontSize="lg"
              fontWeight="extrabold"
            >
              Hide it
            </chakra.span>
            <LinkBox
              as="button"
              display="inline-flex"
              rounded="md"
            >
              <LinkOverlay href={hideit_link} isExternal>
                <Image
                  src={play_badge}
                  fit="cover"
                  w="full"
                  loading="lazy"
                />
              </LinkOverlay>
            </LinkBox>
          </Flex>
          <Flex bg="brand.400">
            <Image
              src={vault_app}
              alt="Mobile phone with an app open"
              fit="cover"
              w="full"
              h={{ base: 64, md: "full" }}
              loading="lazy"
            />
          </Flex>
          <Flex
            direction="column"
            alignItems="center"
            justifyContent="center"
            px={{ base: 4, md: 8, lg: 20 }}
            py={24}
            zIndex={3}
          >
            <chakra.span
              color={useColorModeValue("brand.600", "gray.300")}
              fontSize="lg"
              fontWeight="extrabold"
            >
              Photo Vault
            </chakra.span>
            <LinkBox
              as="button"
              display="inline-flex"
              rounded="md"
            >
              <LinkOverlay href={vault_link} isExternal>
                <Image
                  src={play_badge}
                  fit="cover"
                  w="full"
                  loading="lazy"
                />
              </LinkOverlay>
            </LinkBox>
          </Flex>
        </SimpleGrid>
      </Flex>
      <Flex
        bg={useColorModeValue("black", "#00aaff")}
        px={20}
        py={10}
        w="auto"
        justifyContent="center"
        alignItems="center"
      >
        <Box>
          <Link
            fontSize={12}
            color={useColorModeValue("white", "white")}
            px={5}
            href={hideit_privacy_link}
            isExternal
          >
            Hide it Privacy Policy
          </Link>
          <Link
            fontSize={12}
            color={useColorModeValue("white", "white")}
            px={5}
            href={vault_privacy_link}
            isExternal
          >
            Photo Vault Privacy Policy
          </Link>
          <Link
            fontSize={12}
            color={useColorModeValue("white", "white")}
            px={5}
            href={contact_link}
          >
            Contact Us
          </Link>
        </Box>
      </Flex>
    </Box>
  );
};

export default Landing;
